// removed by extract-text-webpack-plugin
module.exports = {"container":"prescription-details__container___2iN67","expandJsonContainer":"prescription-details__expandJsonContainer___1y4NK"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/prescription/prescription-details.css
// module id = 1181
// module chunks = 0